export const VisitPharmacy = {
    path: '/visits/pharmacy',
    name: 'visits.pharmacy',
    component: () => import('@/views/Visit/VisitPharmacyPage.vue'),
    children: [
        {
            path: '/visits/pharmacy/view/:id',
            name: 'visits.pharmacy.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'pharmacy'}
        },
        {
            path: '/visits/pharmacy/customer/view/:id',
            name: 'visits.pharmacy.customer.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
    ]
}